import React from "react";
import "./Blog_card.css";
import parse from "html-react-parser";
import { formatDate } from "../../../utils/common";
function Blog_card({ blog, blogDetails, IMG_URL }) {
  // ✅ whichever data comes, use it
  const data = blogDetails || blog;

  // ✅ prevent crash
  if (!data) return null;

  return (
    <>
      <section className="Blog_card_holder">
        <div className="Blog_card">
          <h5>{formatDate(data?.createdAt)}</h5>

          <h4>{data.name}</h4>
          <div className="blog_small_card_holder">
            <p>{data?.description}</p>
          </div>

          <div className="img_holder">
            <img
              src={IMG_URL + data?.image}
              alt="blog img"
              className="product_img"
            />
          </div>

          <div className="blog_details_card_holder">
            <p>{parse(data?.long_description || "")}</p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Blog_card;
